import {
  PickPlanSummaryCardSubtitle,
  PickPlanSummaryCardTitle,
  PickPlanSummaryCardWrapper,
} from './PickPlanSummaryCard.style';

export const PickPlanSummaryCard = () => (
  <PickPlanSummaryCardWrapper>
    <PickPlanSummaryCardTitle>Healing doesn’t have to be lonely or expensive</PickPlanSummaryCardTitle>
    <PickPlanSummaryCardSubtitle>
      With Circles, support is always at your fingertips—anytime, anywhere. Start your journey today.
    </PickPlanSummaryCardSubtitle>
  </PickPlanSummaryCardWrapper>
);
